import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { FaArrowDown } from 'react-icons/fa6';

import TypedComponent from './TypedComponent';

const HeroText = () => {
  const textRef = useRef(null);
  const initialsRef = useRef(null);
  const circleRef = useRef(null);
  const arrowRef = useRef(null);

  useEffect(() => {
    const textRefElement = textRef.current;
    const initialRefElement = initialsRef.current;
    const circleRefElement = circleRef.current;
    const arrowRefElement = arrowRef.current;

    gsap.to(textRefElement, {
      translateX: '0px',
      duration: 1.7,
      delay: 2.5,
      opacity: 1,
    });

    gsap.to(initialRefElement, {
      delay: 3,
      duration: 1,
      translateY: '0px',
      opacity: 1,
    });

    gsap.to(circleRefElement, {
      opacity: 1,
      delay: 5.5,
      duration: 1,
    });

    gsap.to(arrowRefElement, {
      opacity: 1,
      delay: 5,
      duration: 1,
    });

    gsap.to(arrowRefElement, {
      repeat: -1,
      yoyo: true,
      duration: 1.2,
      scale: 1.1,
      ease: 'linear',
    });

    //text rotation
    const text = document.querySelector(`#circle-text`);
    text.innerHTML = text.innerText
      .split('')
      .map(
        (char, i) =>
          `<span style="transform:rotate(${i * 5.2}deg)">${char}</span>`
      )
      .join('');
  }, []);

  return (
    <div id="hero-text">
      <div id="container">
        <div ref={initialsRef} id="initial">
          D.Boyce
        </div>
        {/* <div id="illustration">
          <img width={160} src={Pic} alt="illustration of myself" />
        </div> */}
        <div ref={textRef} id="name-title">
          Daniel Boyce
          <div id="typed">
            <TypedComponent />
          </div>
          <div id="brief">
            Web Developer based in Ireland. Enjoys overcoming a good challenge.
            Open to inquiries. The harder the challenge, the greater the
            opportunity for progress and self-improvement.
          </div>
        </div>

        <div id="circle" ref={circleRef}>
          <div id="circle-text">
            <p>
              Javascript - Typescript - Java - Powershell - React - Redux - Node
              -
            </p>
          </div>
        </div>

        <div ref={arrowRef} id="scroll">
          <FaArrowDown />
          <div id="scroll-text">Scroll down</div>
        </div>
      </div>
    </div>
  );
};

export default HeroText;
